import { NgModule } from '@angular/core';

import { CommonFieldStatusesDirective } from './common-field-statuses.directive';

@NgModule({
  declarations: [CommonFieldStatusesDirective],
  exports: [CommonFieldStatusesDirective],
})
export class CommonFieldStatusesModule {}
